export const handleSaveImage = ({ chartRef, fileName, title }) => {
  // Try to get ECharts instance from ReactECharts wrapper first
  let echartsInstance = chartRef.current?.getEchartsInstance?.();

  // If that fails, try to get it directly (for direct echarts usage)
  if (!echartsInstance && chartRef.current) {
    // Check if chartRef.current is already an echarts instance
    echartsInstance = chartRef.current.getDataURL ? chartRef.current : null;
  }

  if (echartsInstance) {
    // Get current options
    const options = echartsInstance.getOption();

    // Add title if provided and not already in options
    if (title && !options.title) {
      options.title = {
        text: title,
        left: 'left',
        top: 10,
        textStyle: {
          fontSize: 14,
          fontWeight: 'bold',
        },
      };

      // Apply the updated options
      echartsInstance.setOption(options, true);
    }

    const dataURL = echartsInstance.getDataURL({
      type: 'png',
      pixelRatio: 2,
      backgroundColor: '#fff',
    });

    // Create a download link
    const link = document.createElement('a');
    link.href = dataURL;
    link.download = `${fileName}${title ? '_' + title : ''}.png`;
    link.click();
  }
};
